<h2>{{titleTranslates | translateObject:'title':language}}</h2>
<ng-content></ng-content>
